import axios from 'axios';

import { apiRoute } from '../../utils/api';
import { getSelectedCircles } from '../circles/reducer';
import { getSelectedTypes } from '../types/reducer';
import { getSelectedFunds } from '../funds/reducer';
import { getSelectedYears } from '../years/reducer';
import { closeDropdowns } from '../actions';
import * as fromFiles from '../files/reducer';
import {
	UPDATE_CURRENT_PAGE,
	SET_CURRENT_PAGE,
	ON_SEARCH_CHANGE,
	SET_FILE_VIEW,
	SET_FILE_SORT_ORDER,
	SET_FILTERED_IDS,
} from '../types';

const setCurrentPage = (currentPage = 1) => {
	return {
		type: SET_CURRENT_PAGE,
		payload: currentPage,
	}
}

const getFilteredIds = (...args) => {
	let ids = [];

	args.forEach(el => {
		// skip to next iteration if element is empty
		if (!el.length) {
			return;
		}

		// set ids for first element that is not empty
		if (!ids.length) {
			ids = [...el];
			return;
		}

		ids = [...ids.filter(id => el.includes(id))];
	});
	return ids;
}

export const updateCurrentPage = (update, current, max) => {
	return dispatch => {
		if ((update < 0 && current !== 1) || (update > 0 && current !== max)) {
			dispatch({
				type: UPDATE_CURRENT_PAGE,
				payload: update,
			});
		}
		return;	
	}
}

export const setFilteredIds = ids => {
	return {
		type: SET_FILTERED_IDS,
		payload: ids,
	}
}

export const prepareFilteredIds = (dispatch, getState) => {
	const state = getState();
	const { circles, types, funds, years, files } = state;
	const searchTerm = fromFiles.getSearchFilter(files);
	const selectedCircles = getSelectedCircles(circles);
	const selectedTypes = getSelectedTypes(types);
	const selectedFunds = getSelectedFunds(funds);
	const selectedYears = getSelectedYears(years);
	let ids;

	//set a base of ids
	if (selectedCircles.length || selectedTypes.length || selectedFunds.length || selectedYears.length) {
		const fileIdsBySelectedCircles = fromFiles.getFilesBySelectedCircles(files, selectedCircles);
		const fileIdsBySelectedTypes = fromFiles.getFilesBySelectedTypes(files, selectedTypes);
		const fileIdsBySelectedFunds   = fromFiles.getFilesBySelectedFunds(files, selectedFunds);
		const fileIdsBySelectedYears   = fromFiles.getFilesBySelectedYears(files, selectedYears);
	
		ids = getFilteredIds(fileIdsBySelectedCircles, fileIdsBySelectedTypes, fileIdsBySelectedFunds, fileIdsBySelectedYears);
	} else {
		ids = [...fromFiles.getIds(files)];
	}

	if (searchTerm) {
		const filesFromIds = fromFiles.getFilesFromIds(files, ids);

		ids = [...filesFromIds.filter(file => {
			return file.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
		}).map(file => {
			return file.id
		})];
	}
	
	dispatch(setCurrentPage());
	
	return dispatch(setFilteredIds(ids));
}

export const setFileViewed = file => {
	return dispatch => {
		dispatch(closeDropdowns());
		return axios.patch(`${apiRoute}/dale/v1/files/${file}`, {'viewed': true});
	}
}

export const onSearchChange = value => {
	return dispatch => { 
		dispatch({
			type: ON_SEARCH_CHANGE,
			payload: value,
		})
		return dispatch(prepareFilteredIds);		
	}
}

export const setView = type => ({
	type: SET_FILE_VIEW,
	payload: type,
})

export const setFileSortOrder = name => {
	return (dispatch, getState) => {
		const state = getState();
		const sort = state.files.filter.sort;
		const order = state.files.filter.order;
		let newOrder = order;

		if (name === sort) {
			newOrder = !order;
		}

		dispatch({
			type: SET_FILE_SORT_ORDER,
			payload: {
				name,
				order: newOrder,	
			},
		});

		const filteredFiles = fromFiles.getFilteredFiles(state.files);		
		const Ids = getSortedFileIds(filteredFiles, newOrder, name);

		return dispatch(setFilteredIds(Ids));
	}

};

const getSortedFileIds = (filteredFiles, order, condition) => { 
	return [...filteredFiles.sort((a,b) => {
		let conditionA, conditionB;

		if (condition === "file") { 
			conditionA = a.title.toUpperCase();
			conditionB = b.title.toUpperCase();
		}

		if (condition === "date") { 
			conditionA = new Date(a.date);
			conditionB = new Date(b.date);
		}

		let comparison = 0;
		if (conditionA > conditionB) {
			comparison = 1;
		} else if(conditionA < conditionB) {
			comparison = -1;
		}

		if(order === false) {
			return comparison * -1;
		}

		return comparison;
	}).map(obj => obj.id)];
}


// WEBPACK FOOTER //
// ./src/store/files/actions.js